import { ASSET_REDUCER } from "../constants/enums";

type ASSET = {
  localCode: string;
  ownerShip: string;
  type: string;
  description: string;
  location: string;
  department: number | null;
  category: number | null;
  scope: number | null;
  departmentName: string;
  categoryName: string;
  emissionSource: number | null;
  emissionSubSource: number | null;
  engine: number | null;
  fuel: number | null;
  country: number | null;
  uom: number | null;
  uomName: string;
  noOfUnits: number;
  value: number | null;
  notes: string;
  emissionType: number | null;
  emissionSubType: number | null;
  emissionMethod: number | null;
  emissionSourceName: string | null;
  currency: number | null;
  currencyName: string | null;
  emissionCategory: string | null;
};

export const defaultAssetState: ASSET = {
  localCode: "",
  ownerShip: "",
  type: "",
  description: "",
  location: "",
  department: null,
  category: null,
  scope: null,
  departmentName: "",
  categoryName: "",
  emissionSource: null,
  emissionSubSource: null,
  engine: null,
  fuel: null,
  country: null,
  uom: null,
  uomName: "",
  noOfUnits: 1,
  value: null,
  notes: "",
  emissionSourceName: "",
  currency: null,
  currencyName: "",
  emissionType: null,
  emissionSubType: null,
  emissionMethod: null,
  emissionCategory: "",
};

const assetReducer = (state: any, action: any) => {
  switch (action.type) {
    case ASSET_REDUCER.SET_INPUT_FIELD:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case ASSET_REDUCER.SET_SELECTED_DROPDOWN:
      if (
        action.payload.name === "Department" ||
        action.payload.name === "Category" ||
        action.payload.name === "scopeCategories" ||
        action.payload.name === "emissionFactorSources" ||
        action.payload.name === "methods" ||
        action.payload.name === "activityData" ||
        action.payload.name === "uoms" ||
        action.payload.name === "currency"
      ) {
        return {
          ...state,
          ...action.payload.value,
        };
      } else {
        return {
          ...state,
          [action.payload.name]: action.payload.value,
        };
      }
    case ASSET_REDUCER.SET_INITIAL_STATE:
      {
        return {
          ...state,
          ...action.payload,
        };
      }

      //   case "SET_SELECTED_OWNERSHIP_TYPE":
      //     return {
      //       ...state,
      //       ownerShip: action.payload,
      //     };
      //   case "SET_SELECTED_ASSET_TYPE":
      //     return {
      //       ...state,
      //       type: action.payload,
      //     };
      //   case "SET_SELECTED_EMISSION_SOURCE":
      //     return {
      //       ...state,
      //       emissionSource: action.payload,
      //     };
      //   case "SET_SELECTED_UOMS":
      //     return {
      //       ...state,
      //       uomName: action.payload,
      //     };
      //   case "SET_SELECTED_DEPARTMENT":
      //     return {
      //       ...state,
      //       departmentName: action.payload,
      //     };
      //   case "SET_SELECTED_CATEGORY":
      //     return {
      //       ...state,
      //       categoryName: action.payload,
      //     };
      //   case "SET_SELECTED_CURRENCY":
      return {
        ...state,
        selectedCurrency: action.payload,
      };
    default:
      return state;
  }
};

export default assetReducer;
